(() => {
  function init() {
    const cards = [...document.querySelectorAll('[data-mb-gallery] .mb-media-card')];
    const controls = [...document.querySelectorAll('[data-gallery-controls]')];
    let category = '', kind = '';
    const categoryKey = value => value.trim().toLocaleLowerCase('nl');
    const categories = new Map();
    cards.forEach(card => {
      const name = card.dataset.category.trim();
      if (name && !categories.has(categoryKey(name))) categories.set(categoryKey(name), name.charAt(0).toLocaleUpperCase('nl') + name.slice(1));
    });
    function apply() {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = Boolean((category && categoryKey(card.dataset.category) !== category) || (kind && card.dataset.kind !== kind));
        if (!card.hidden) visible++;
        if (card.hidden) card.querySelectorAll('video').forEach(video => video.pause());
      });
      document.querySelectorAll('[data-gallery-empty]').forEach((empty, index) => { empty.hidden = visible > 0 || index > 0; });
      controls.forEach(control => control.querySelectorAll('button').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.axis === 'category' ? button.dataset.value === category : button.dataset.value === kind));
      }));
    }
    controls.forEach(control => {
      control.replaceChildren();
      const row = (axis, label, values) => {
        const group = document.createElement('div'); group.className = 'mb-filter-row'; group.setAttribute('role', 'group'); group.setAttribute('aria-label', label);
        values.forEach(([value, title]) => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'mb-filter'; button.textContent = title; button.dataset.axis = axis; button.dataset.value = value;
          button.addEventListener('click', () => { if (axis === 'category') category = value; else kind = value; apply(); }); group.append(button);
        }); control.append(group);
      };
      row('category', control.dataset.categoryLabel, [['', control.dataset.all], ...categories.entries()]);
      row('kind', control.dataset.kindLabel, [['', control.dataset.all], ['photo', control.dataset.photo], ['video', control.dataset.video]]);
    });
    apply();
    document.querySelectorAll('.mb-comparison input').forEach(input => {
      input.oninput = () => input.closest('.mb-comparison').style.setProperty('--position', `${input.value}%`);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();
